// extracted by mini-css-extract-plugin
module.exports = {"sellPointsModule":"Fifth_sellPointsModule__tl2LL"};